module.exports = __webpack_public_path__ + "img/overfold-card-2.a08d188e.png";